import { render, staticRenderFns } from "./QuestionsStatistics.vue?vue&type=template&id=34329f26&scoped=true&"
import script from "./QuestionsStatistics.vue?vue&type=script&lang=js&"
export * from "./QuestionsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsStatistics.vue?vue&type=style&index=0&id=34329f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34329f26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VPagination,VProgressCircular,VRow,VSelect,VTextField})
